var CryptoJS = require('./AES')
var key = CryptoJS.enc.Utf8.parse("300f6e1bbd0c9b9be11c8292f11f083b");
var iv = CryptoJS.enc.Utf8.parse('SWQZ_FLY_RICH_UP');


function Encrypt(word) {
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });

  return encrypted.ciphertext.toString().toUpperCase();
  //toString()  ת�ַ���   toUpperCase()  ת���ɴ�д�����Բ�ʹ��ת��д��
}

function Decrypt(word) {
  var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  var decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

function tableDragable(ref) {
  this.$nextTick(() => {
    // console.log(this.$refs[ref]);
    const tableBodyWrapper = this.$refs[ref].$el.querySelector('.el-table__body-wrapper');
    
    if (!tableBodyWrapper) {
      console.error('找不到表体。');
      return;
    }

    let isDown = false;
    let startX, scrollLeft;

    tableBodyWrapper.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - tableBodyWrapper.offsetLeft;
      scrollLeft = tableBodyWrapper.scrollLeft;
      tableBodyWrapper.style.cursor = 'grabbing';
    });

    tableBodyWrapper.addEventListener('mouseleave', () => {
      isDown = false;
      tableBodyWrapper.style.cursor = 'grab';
    });

    tableBodyWrapper.addEventListener('mouseup', () => {
      isDown = false;
      tableBodyWrapper.style.cursor = 'grab';
    });

    tableBodyWrapper.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - tableBodyWrapper.offsetLeft;
      const walk = (x - startX) * 2; // scroll-fast
      tableBodyWrapper.scrollLeft = scrollLeft - walk;
    });

    // 隐藏滚动条
    // tableBodyWrapper.style.overflowX = 'hidden';
  });
}


module.exports = {
  Encrypt: Encrypt,
  Decrypt: Decrypt,
  tableDragable: tableDragable
}
